module.exports = __webpack_public_path__ + "static/media/warehouse.ff0cbe0e.svg";